<div class="empty_space"></div>

<div class="container">
	<div class="row">
		<div class="col-md-12">
			<div class="notfound">
				<span>4</span>
				<img src="./assets/img/wow_emoticon.png" />
				<span>4</span>
			</div>
			<h2 class="title">{{'Oops! Pagina non trovata.' | translate}}</h2>
		</div>
	</div>
</div>
